import * as Sentry from '@sentry/react';
import { setRuntimeContext } from './runtimeContext';

export function updateUserContextInSentry(user: { _id: string; email?: string | null; name?: string | null } | null | undefined): void {
  if (user?._id) {
    Sentry.setUser({ 
      id: user._id, 
      email: user.email || undefined, 
      username: user.name || undefined 
    });
    setRuntimeContext({ 
      user: { 
        id: user._id, 
        email: user.email || undefined, 
        name: user.name || undefined 
      } 
    });
  } else {
    Sentry.setUser(null);
    setRuntimeContext({ user: null });
  }
}

